/**
 * Result of the last GIM synchronization (settings/{organizationId}/gim/status)
 */
export class GimSyncStatus {
  /** Date of the last run */
  date: Date | null;
  /** Date of the last successful run */
  lastSuccessDate: Date | null;
  success: boolean;
  /** Code of the error, described by gim.error.<code> */
  errorCode: string;
  errorParams: Record<string, string | number>;
  /** Technical message of the error */
  error: string;
  summary: { total: number, created: number, skipped: number } | null;

  constructor(data?: any) {
    this.date = data?.date?.toDate ? data.date.toDate() : null;
    this.lastSuccessDate = data?.lastSuccessDate?.toDate ? data.lastSuccessDate.toDate() : null;
    this.success = data?.success ?? true;
    this.errorCode = data?.errorCode ?? '';
    this.errorParams = data?.errorParams ?? {};
    this.error = data?.error ?? '';
    this.summary = data?.summary ?? null;
  }
}
